// extracted by mini-css-extract-plugin
export default {"divBanner":"Banner_divBanner__VsN4B","portalLabel":"Banner_portalLabel__e9l4O"};